import { useState, useEffect, useRef } from 'react';

const useInView = (
  options?: IntersectionObserverInit,
  shouldObserve = true
) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!shouldObserve) return;

    const observer = new IntersectionObserver(([entry]) => {
      setIsVisible(entry.isIntersecting);
    }, options);

    if (ref.current) {
      observer.observe(ref.current);
    }

    // eslint-disable-next-line consistent-return
    return () => {
      if (ref.current) {
        // eslint-disable-next-line react-hooks/exhaustive-deps
        observer.unobserve(ref.current);
      }
    };
  }, [shouldObserve, options]);

  return [ref, isVisible] as const;
};

export default useInView;
